
import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import CardNoteComponent from './CardNoteComponent';
import ProgressBarWrapperComponent from './ProgressBarWrapperComponent';
import './Card.sass';

const CarrierEventResponseEfficencyCard = ({ carrierLoading }) => {

    const { t } = useTranslation();
    const pageName = 'carrierEventResponse';
    const [loading, setLoading] = useState(() => carrierLoading);
    const mockLoading = [{}, {}, {}, {}];

    const { summary: { carrierEventResponse: { data: { summaryResponse, responseExpectationInHours }, isLoading } } } = useSelector(state => state.chartSummary);

    useEffect(() => {
        setLoading(carrierLoading || isLoading);
    }, [carrierLoading, isLoading]);

    return (
        <div className='card1' data-testid="carrierEventResponseEfficiencyCard">
            <div className='titleBox'>
                <Typography variant='h2' data-testid='carrier-event-efficiency' className='titleStyle'>{t('carrier_event_response_efficiency')}</Typography>
            </div>
            <div className='subTitle'>
                <Typography variant='h3' data-testid='total-response-rate' className='subTitleStyleCER'>{t('total_response_rate')}</Typography>
            </div>
            <Grid container className='subtitleContsiner'>
                <Grid item xs={6} className='subtitleCER'>
                    <Typography variant='h5' data-testid='number-of-pickstops' className='subTitleStyleCER'>{`${t('number_of_pickstops')}: ${summaryResponse?.responseRatePickupStopNumbers || summaryResponse?.responseRatePickupStopNumbers === 0 ? summaryResponse?.responseRatePickupStopNumbers : '-'}`}</Typography>
                </Grid>
                <Grid item xs={6} className='subtitleCER'>
                    <Typography variant='h5' data-testid='number-of-dropstops' className='subTitleStyleCER'>{`${t('number_of_dropstops')}: ${summaryResponse?.responseRateDropStopNumbers || summaryResponse?.responseRateDropStopNumbers === 0 ? summaryResponse?.responseRateDropStopNumbers : '-'}`}</Typography>
                </Grid>
            </Grid>
            <div className='styleCRECBars'>
                {
                    (loading ? mockLoading : summaryResponse?.responseRate)?.map((item, index) => (<div className='styleFKYCBar' key={item.stopEventType}>
                        <ProgressBarWrapperComponent
                            progressBarData={{
                                title: `${t(item?.label)}`,
                                subtitle1: `${item?.responsePercentage}%`,
                                subtitle2: `${item?.targetPercentage}% ${t('target')}`,
                                value1: item?.greenCount,
                                value2: item?.redCount,
                                value1Title: `${item?.greenCount} ${t('response_received')}`,
                                value2Title: `${item?.redCount} ${t('missing_response')}`,
                                subtitleValue1: item?.responsePercentage,
                                subtitleValue2: item?.targetPercentage,
                                color: "primary"
                            }}
                            card={true}
                            gotoPath={pageName}
                            loading={loading}
                            eventType={item.label}
                            stopEventType={item.stopEventType}
                            testid={`total-response-chart-${index}`}
                        />
                    </div>))
                }
            </div>

            <Divider className='dividerStyle' />

            <div className='subTitle'>
                <Typography variant='h3' data-testid='on-time-response-rate' className='subTitleStyleCER'>{t('on_time_response_rate')}</Typography>
                <div className='responseBox'>
                    <Typography variant='h3' data-testid='response-expectation' className='responseExpectation'>{t('response_expectation')}</Typography>
                    <Typography variant='h4' className='hoursText' data-testid='response-expectation-in-hrs' >{`${loading || !responseExpectationInHours ? '-' : responseExpectationInHours} ${t('hours')}`}</Typography>
                </div>
            </div>
            <Grid container className='subtitleContsiner'>
                <Grid item xs={6} className='subtitleCER'>
                    <Typography variant='h5' data-testid='OTR-number-of-pickstops' className='subTitleStyleCER'>{`${t('number_of_pickstops')}: ${summaryResponse?.onTimeResponsePickupStopNumbers || summaryResponse?.onTimeResponsePickupStopNumbers === 0 ? summaryResponse?.onTimeResponsePickupStopNumbers : '-'}`}</Typography>
                </Grid>
                <Grid item xs={6} className='subtitleCER'>
                    <Typography variant='h5' data-testid='OTR-number-of-dropstops' className='subTitleStyleCER'>{`${t('number_of_dropstops')}: ${summaryResponse?.onTimeResponseDropStopNumbers || summaryResponse?.onTimeResponseDropStopNumbers === 0 ? summaryResponse?.onTimeResponseDropStopNumbers : '-'}`}</Typography>
                </Grid>
            </Grid>
            <div className='styleCRECBars'>
                {
                    (loading ? mockLoading : summaryResponse?.onTimeResponse)?.map((item, index) => (<div className='styleFKYCBar' key={item.stopEventType}>
                        <ProgressBarWrapperComponent
                            progressBarData={{
                                title: `${t(item?.label)}`,
                                subtitle1: `${item?.onTimeResponsePercentage}%`,
                                subtitle2: `${item?.targetPercentage}% ${t('target')}`,
                                value1: item?.greenCount,
                                value2: item?.redCount,
                                value1Title: `${item?.greenCount} ${t('ontime_response_received')}`,
                                value2Title: `${item?.redCount} ${t('delayed_missing_response')}`,
                                subtitleValue1: item?.onTimeResponsePercentage,
                                subtitleValue2: item?.targetPercentage,
                                color: "primary"
                            }}
                            card={true}
                            gotoPath={pageName}
                            loading={loading}
                            eventType={item?.label}
                            stopEventType={item?.stopEventType}
                            testid={`on-time-response-chart-${index}`}
                        />
                    </div>))
                }
            </div>
            <CardNoteComponent testid={pageName} note={t('kpi_note_delivery_date')} />
        </div>
    )
}

export default CarrierEventResponseEfficencyCard;